import { render, staticRenderFns } from "./lawyerSaid.vue?vue&type=template&id=25fb4bae&"
import script from "./lawyerSaid.vue?vue&type=script&lang=js&"
export * from "./lawyerSaid.vue?vue&type=script&lang=js&"
import style0 from "./lawyerSaid.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports